__turbopack_context__.v({
  "category": "ehxblq_category",
  "collapseOut": "ehxblq_collapseOut",
  "emptyState": "ehxblq_emptyState",
  "emptyStateHeading": "ehxblq_emptyStateHeading",
  "listContainer": "ehxblq_listContainer",
  "navigatingOut": "ehxblq_navigatingOut",
  "noResults": "ehxblq_noResults",
  "noResultsText": "ehxblq_noResultsText",
  "relatedArticles": "ehxblq_relatedArticles",
  "resultsCount": "ehxblq_resultsCount",
  "semibold": "ehxblq_semibold",
});
